export default {
    USER_CLICK_LOGIN: '[USER] CLICK_LOGIN',
    USER_LOGIN_RESULT: '[USER] LOGIN_RESULT',
    USER_LOGIN_ERROR: '[USER] LOGIN_ERROR',
    USER_ASSIGN_POS: '[USER] ASSIGN_POS',
    USER_ASSIGN_POS_RESPONSE: '[USER] ASSIGN_POS_RESPONSE',
    USER_ASSIGN_POS_ERROR: '[USER] ASSIGN_POS_ERROR',
    USER_CLOSE_POPUP: '[USER] CLOSE_POPUP',
    USER_GET_LOGO: '[USER] GET_LOLO',
    USER_GET_LOGO_SUCCESS: '[USER] GET_LOGO_SUCCESS',
    USER_GET_LOGO_ERROR: '[USER] GET_LOGO_ERROR',
    USER_GET_COUNTRIES: '[USER] GET_COUNTRIES',
    USER_CHANGE_INFORMATION: '[USER] CHANGE_INFORMATION',
    USER_CONTINUE_LOGIN : '[USER] CONTINUE_LOGIN',
    USER_AFTER_CONTINUE_LOGIN : '[USER] AFTER_CONTINUE_LOGIN'
};


// WEBPACK FOOTER //
// ./src/view/constant/UserConstant.js